import { render, staticRenderFns } from "./ValueVoucherType.vue?vue&type=template&id=4228c04c&scoped=true"
import script from "./ValueVoucherType.vue?vue&type=script&lang=js"
export * from "./ValueVoucherType.vue?vue&type=script&lang=js"
import style0 from "./ValueVoucherType.vue?vue&type=style&index=0&id=4228c04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228c04c",
  null
  
)

export default component.exports